import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Form, Icon, message, Breadcrumb, Select, DatePicker } from 'antd';
import { Button, ConfigProvider, Tabs, Table, Input } from 'antd';
import { apis } from '../api/index.js';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import moment from 'moment';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import './SmartEye.css';
import throttle from 'lodash.throttle';
import { getParams, changeListWidth, getProvinceOption } from '../utils';
import { formatFromTime, formatToTime, setScrollTop } from '../utils';
import { getDay, getProjectOption, getArea, instProjectInfo } from '../utils';
import { calcTableHeight, showMoreSearch, breadItem } from '../utils';
import { toolTipTitle, loadingOptionsHtml } from '../utils';
import TableEmpty from '../components/TableEmpty.js';

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const { Option } = Select;
class DataForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      provinceList: [],
      i18nextLng: 'zh-CN',
      marketDataList: [],
      marketDataRateList: [],
      marketDataRateList3: [],
      marketDataRateList4: [],
      pageSize: 20,
      totalTB2: 0,
      totalTB1: 0,
      totalTB3: 0,
      totalTB4: 0,
      totalTB5: 0,
      totalTB6: 0,
      pageTB1: 1,
      pageTB2: 1,
      pageTB3: 1,
      pageTB4: 1,
      pageTB5: 1,
      pageTB6: 1,
      searchLoading: false,
      tableHeight: 0,
      moreFilter: true,
      showMoreFilter: false,
      changeTabState: 0,
      changeSelectState: '连续7天未传片日期',
      changeSelectState2: '连续7天登录',
      startTime: getDay(-29),
      endTime: getDay(0),
      projectList: [],
    };

    this.throttledDataList = throttle(newState => {
      setScrollTop();
      this.getMarketData(newState);
      this.getMarketDataRate(newState);
      this.getSnapshotByPage(newState);
      this.instLoginByPage(newState);
      this.synOnlineDetail(newState);
      this.marketDataOnlineDetail(newState);
    }, 1000);
    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(265) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    form: PropTypes.object,
  };

  componentDidMount() {
    this.getProvince();
    this.throttledDataList();
    window.addEventListener('resize', () => this.formResize());
    this.formResize();
    this.getInstProjectInfo();
  }

  //获取项目列表
  getInstProjectInfo = async () => {
    const res = await instProjectInfo();
    this.setState({ projectList: res.list });
  };

  //数据图表1的数据
  getMarketData = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      startTime: updatedState.startTime,
      endTime: updatedState.endTime,
      pageNum: updatedState.pageTB1,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      projectIds: updatedState.projectIds,
    };
    apis.marketData(post).then(res => {
      this.setState({ searchLoading: false });
      if (res.code === '0') {
        this.setState({
          marketDataList: res.data.list,
          totalTB1: res.data.total,
        });
      } else {
        if (res.code === '1009') this.props.history.push('/login');
        message.error(res.message);
      }
    });
  };

  //数据图表2的数据
  getMarketDataRate = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      startTime: updatedState.startTime,
      endTime: updatedState.endTime,
      pageNum: updatedState.pageTB2,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      projectIds: updatedState.projectIds,
    };
    apis.marketDataRate(post).then(res => {
      if (res.code === '0') {
        this.setState({
          marketDataRateList: res.data.list,
          totalTB2: res.data.total,
        });
      } else {
        if (res.code === '1009') this.props.history.push('/login');
        message.error(res.message);
      }
    });
  };
  // 表3中的数据
  getSnapshotByPage = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      startTime: updatedState.startTime,
      endTime: updatedState.endTime,
      pageNum: updatedState.pageTB3,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      unUpDcmDays: parseInt(updatedState.changeSelectState.split('连续')[1]),
      projectIds: updatedState.projectIds,
    };
    apis.getSnapshotByPage(post).then(res => {
      if (res.code === '0') {
        this.setState({
          marketDataRateList3: res.data.list,
          totalTB3: res.data.total,
        });
      } else {
        if (res.code === '1009') this.props.history.push('/login');
        message.error(res.message);
      }
    });
  };
  // 表4中的数据
  instLoginByPage = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      startTime: updatedState.startTime,
      endTime: updatedState.endTime,
      pageNum: updatedState.pageTB4,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      loginDays: parseInt(updatedState.changeSelectState2.split('连续')[1]),
      projectIds: updatedState.projectIds,
    };
    apis.instLoginByPage(post).then(res => {
      if (res.code === '0') {
        this.setState({
          marketDataRateList4: res.data.list,
          totalTB4: res.data.total,
        });
      } else {
        if (res.code === '1009') this.props.history.push('/login');
        message.error(res.message);
      }
    });
  };
  //表5中的数据
  synOnlineDetail = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      pageNum: updatedState.pageTB5,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      projectIds: updatedState.projectIds,
    };
    apis.synOnlineDetail(post).then(res => {
      if (res.code === '0') {
        this.setState({
          marketDataRateList5: res.data.list,
          totalTB5: res.data.total,
        });
      } else {
        if (res.code === '1009') this.props.history.push('/login');
        message.error(res.message);
      }
    });
  };
  //表6中的数据
  marketDataOnlineDetail = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = {
      pageNum: updatedState.pageTB6,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      startTime: updatedState.startTime,
      endTime: updatedState.endTime,
      projectIds: updatedState.projectIds,
    };
    apis.marketDataOnlineDetail(post).then(res => {
      if (res.code === '0') {
        this.setState({
          marketDataRateList6: res.data.list,
          totalTB6: res.data.total,
        });
      } else {
        if (res.code === '1009') this.props.history.push('/login');
        message.error(res.message);
      }
    });
  };
  //省份列表
  getProvince = async () => {
    const data = await getArea(0);
    this.setState({ provinceList: data });
  };

  handleSearch = e => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let fromTime = formatFromTime(values.date);
        let toTime = formatToTime(values.date);
        const newState = {
          startTime: fromTime,
          endTime: toTime,
          province: values.area,
          searchLoading: true,
          unUpDcmDays: values.unUpDcmDays,
          loginDays: values.loginDays,
          projectIds: values.project ? values.project.join(',') : '',
        };
        this.throttledDataList(newState);
      }
    });
  };

  handleReset = () => {
    this.props.form.resetFields();
    this.setState({
      changeSelectState: '连续7天未传片日期',
      changeSelectState2: '连续7天登录',
    });
  };

  getColumns1 = () => {
    const columns = [
      { title: '日期', dataIndex: 'date', key: 'date', width: '10%' },
      {
        title: (
          <div>
            <span className="table-title">机构数</span>
            {toolTipTitle('开通的机构数', 'topLeft')}
          </div>
        ),
        dataIndex: 'institutions',
        key: 'institutions',
        width: '10%',
      },
      {
        title: (
          <div>
            <span className="table-title">新增机构数</span>
            {toolTipTitle('新开通的机构数', 'topLeft')}
          </div>
        ),
        dataIndex: 'newInstitutions',
        key: 'newInstitutions',
        width: '10%',
      },
      {
        title: '日传片量',
        dataIndex: 'dicomNum',
        key: 'dicomNum',
        width: '10%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: '开机数量',
        dataIndex: 'onlineNum',
        key: 'onlineNum',
        width: '10%',
        render: value => <span>{value}</span>,
      },
      {
        title: '日传片活跃机构数',
        dataIndex: 'dicomInstNum',
        key: 'dicomInstNum',
        width: '15%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">登录活跃机构数</span>
            {toolTipTitle(
              '登录过网页或者客户端的机构用户对应的机构数',
              'topLeft'
            )}
          </div>
        ),
        dataIndex: 'activeInstitutions',
        key: 'activeInstitutions',
        width: '15%',
      },
      {
        title: (
          <div>
            <span className="table-title">登录活跃用户数</span>
            {toolTipTitle(
              '登录过网页或者客户端的机构用户对应的用户数（不包括体验用户）',
              'topLeft'
            )}
          </div>
        ),
        dataIndex: 'activeUsers',
        key: 'activeUsers',
        width: '10%',
      },
      {
        title: (
          <div>
            <span className="table-title">新增用户数</span>
            {toolTipTitle(
              '新开通或者新注册的用户数（不包括体验用户）',
              'topLeft'
            )}
          </div>
        ),
        dataIndex: 'newUsers',
        key: 'newUsers',
        width: '10%',
      },
    ];
    return columns;
  };

  getColumns2 = () => {
    const columns = [
      { title: '日期', dataIndex: 'date', key: 'date2', width: '25%' },
      {
        title: (
          <div>
            <span className="table-title">机构用户产品使用率</span>
            {toolTipTitle('机构活跃用户数/总机构用户数', 'topLeft')}
          </div>
        ),
        dataIndex: 'activeUsersRate',
        key: 'activeUsersRate',
        width: '25%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">机构用户7日留存率</span>
            {toolTipTitle(
              '（7天前活跃，且该天之后7天活跃过的用户为留存用户），留存用户数/7天前活跃用户数',
              'topLeft'
            )}
          </div>
        ),
        dataIndex: 'retention7Rate',
        key: 'retention7Rate',
        width: '25%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: (
          <div>
            <span className="table-title">传片率</span>
            {toolTipTitle('传片的机构数/全部机构数', 'topLeft')}
          </div>
        ),
        dataIndex: 'dicomRate',
        key: 'dicomRate',
        width: '25%',
        render: value => <span>{value || '--'}</span>,
      },
    ];
    return columns;
  };
  getColumns3 = () => {
    const columns = [
      { title: '查询日期', dataIndex: 'date', key: 'date2', width: '20%' },
      {
        title: (
          <div>
            <span className="table-title">{this.state.changeSelectState}</span>
            {toolTipTitle(
              '昨天往前推7日，即T,T-1,T-2,T-3,T-4,T-5,T-6,T表示昨天',
              'topLeft'
            )}
          </div>
        ),
        dataIndex: 'unUpDcmDays',
        key: 'unUpDcmDays',
        width: '20%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: '机构数',
        dataIndex: 'retention7Rate1',
        key: 'retention7Rate1',
        width: '20%',
        render: (list, data) => {
          return <span>{data.instInfos.length || '--'}</span>;
        },
      },
      {
        title: '省份',
        dataIndex: 'retention7Rate',
        key: 'retention7Rate',
        width: '20%',
        className: 'tdNoPadding',
        render: (list, data) => {
          let html =
            data.instInfos.length === 0
              ? '--'
              : data.instInfos.map((item, index) => (
                  <div key={index}>{item.provinceName || '--'}</div>
                ));
          return html;
        },
      },
      {
        title: '机构名称',
        dataIndex: 'dicomRate',
        key: 'dicomRate',
        width: '20%',
        className: 'tdNoPadding',
        render: (list, data) => {
          let html =
            data.instInfos.length === 0
              ? '--'
              : data.instInfos.map((item, index) => (
                  <div key={index}>{item.institutionName || '--'}</div>
                ));
          return html;
        },
      },
    ];
    return columns;
  };
  getColumns4 = () => {
    const columns = [
      { title: '查询日期', dataIndex: 'date', key: 'date2', width: '20%' },
      {
        title: (
          <div>
            <span className="table-title">{this.state.changeSelectState2}</span>
            {toolTipTitle(
              '昨天往前推7日，即T,T-1,T-2,T-3,T-4,T-5,T-6,T表示昨天',
              'topLeft'
            )}
          </div>
        ),
        dataIndex: 'unUpDcmDays',
        key: 'unUpDcmDays',
        width: '20%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: '机构数',
        dataIndex: 'retention7Rate1',
        key: 'retention7Rate1',
        width: '20%',
        render: (list, data) => {
          return <span>{data.instInfos.length || '--'}</span>;
        },
      },
      {
        title: '省份',
        dataIndex: 'retention7Rate',
        key: 'retention7Rate',
        width: '20%',
        className: 'tdNoPadding',
        render: (list, data) => {
          let html =
            data.instInfos.length === 0
              ? '--'
              : data.instInfos.map((item, index) => (
                  <div key={index}>{item.provinceName || '--'}</div>
                ));
          return html;
        },
      },
      {
        title: '机构名称',
        dataIndex: 'dicomRate',
        key: 'dicomRate',
        width: '20%',
        className: 'tdNoPadding',
        render: (list, data) => {
          let html =
            data.instInfos.length === 0
              ? '--'
              : data.instInfos.map((item, index) => (
                  <div key={index}>{item.institutionName || '--'}</div>
                ));
          return html;
        },
      },
    ];
    return columns;
  };
  getColumns5 = () => {
    const columns = [
      {
        title: '机构名称',
        dataIndex: 'institutionName',
        key: 'institutionName',
        width: '50%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: '工作站和DR连通状态',
        dataIndex: 'drOnline',
        key: 'drOnline',
        width: '50%',
        render: value => <div>{this.getTerminalStatus(value)}</div>,
      },
    ];
    return columns;
  };

  getColumns6 = () => {
    const columns = [
      {
        title: '日期',
        dataIndex: 'date',
        key: 'date',
        width: '30%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: '机构名称',
        dataIndex: 'institutionName',
        key: 'institutionName',
        width: '30%',
        render: value => <span>{value || '--'}</span>,
      },
      {
        title: '工作站和DR连通状态',
        dataIndex: 'drOnline',
        key: 'drOnline',
        width: '40%',
        render: value => <div>{this.getTerminalStatus(value)}</div>,
      },
    ];
    return columns;
  };

  getTerminalStatus = value => {
    return (
      <>
        {value === '未连通' ? (
          <span className="data-offline">
            <Icon type="exclamation-circle" theme="filled" />
            &nbsp;未连通
          </span>
        ) : (
          <>
            {value === '已连通' ? (
              <span className="data-online">
                <Icon type="check-circle" theme="filled" />
                &nbsp;已连通
              </span>
            ) : (
              '--'
            )}
          </>
        )}
      </>
    );
  };
  //导出明细
  exportDetailExcel = type => {
    const { startTime, endTime, province, projectIds } = this.state;
    const { changeSelectState, changeSelectState2 } = this.state;
    const post = {
      startTime,
      endTime,
      province,
      unUpDcmDays: parseInt(changeSelectState.split('连续')[1]),
      loginDays: parseInt(changeSelectState2.split('连续')[1]),
      projectIds,
    };
    const search = getParams(post);
    let url = '';
    if (type === 'data1') {
      url = `/ai-web/statistics/marketData/exportExcel?${search}`;
    } else if (type === 'data2') {
      url = `/ai-web/statistics/marketData/exportRateExcel?${search}`;
    } else if (type === 'data3') {
      url = `/ai-web/statistics/marketData/instSnapshotExcel?${search}`;
    } else if (type === 'data4') {
      url = `/ai-web/statistics/marketData/instLoginExcel?${search}`;
    } else if (type === 'data6') {
      url = `/ai-web/statistics/marketData/onlineDetailExcel?${search}`;
    }
    window.open(url);
  };

  //切换页数
  pageOnChange = (type, page) => {
    const updatedState = Object.assign({}, this.state);
    this.setState(updatedState);
    const post = {
      startTime: updatedState.startTime,
      endTime: updatedState.endTime,
      pageSize: updatedState.pageSize,
      province: updatedState.province,
      unUpDcmDays: parseInt(updatedState.changeSelectState.split('连续')[1]),
      loginDays: parseInt(updatedState.changeSelectState2.split('连续')[1]),
    };
    switch (type) {
      case 'tb1': //AI质控
        this.getMarketData({ ...post, pageTB1: page });
        break;
      case 'tb2': //病毒性肺炎
        this.getMarketDataRate({ ...post, pageTB2: page });
        break;
      case 'tb3': //表格三
        this.getSnapshotByPage({ ...post, pageTB3: page });
        break;
      case 'tb4': //表格四
        this.instLoginByPage({ ...post, pageTB4: page });
        break;
      case 'tb5': //实时设备监控
        this.synOnlineDetail({ ...post, pageTB5: page });
        break;
      case 'tb6': //设备监控历史
        this.marketDataOnlineDetail({ ...post, pageTB6: page });
        break;
      default:
        break;
    }
  };

  //显示条数
  showTotal = type => {
    let result = '';
    switch (type) {
      case 'tb1': //AI质控
        result = `共${this.state.totalTB1}条`;
        break;
      case 'tb2': //病毒性肺炎
        result = `共${this.state.totalTB2}条`;
        break;
      case 'tb3': //病毒性肺炎
        result = `共${this.state.totalTB3}条`;
        break;
      case 'tb4': //病毒性肺炎
        result = `共${this.state.totalTB4}条`;
        break;
      case 'tb5':
        result = `共${this.state.totalTB5}条`;
        break;
      case 'tb6':
        result = `共${this.state.totalTB6}条`;
        break;
      default:
        break;
    }
    return result;
  };
  changeTab = e => {
    this.setState({ changeTabState: e });
  };
  changeSelectTime = e => {
    this.setState(
      {
        changeSelectState: `连续${e ? e : 7}天未传片日期`,
      },
      () => {
        this.handleSearch();
      }
    );
  };
  changeSelectTime2 = e => {
    this.setState(
      {
        changeSelectState2: `连续${e ? e : 7}天登录`,
      },
      () => {
        this.handleSearch();
      }
    );
  };

  disabledDate = date => {
    const { dates } = this.state;
    if (!dates) return;
    return (
      date.diff(dates[0], 'month') < -1 || date.diff(dates[0], 'month') > 1
    ); // 保证可选日期跨度只有2天
  };
  onCalendarChange = e => {
    this.setState({ dates: e });
  };
  onOpenChange = open => {
    if (open) this.setState({ dates: undefined });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const columns1 = this.getColumns1();
    const columns2 = this.getColumns2();
    const columns3 = this.getColumns3();
    const columns4 = this.getColumns4();
    const columns5 = this.getColumns5();
    const columns6 = this.getColumns6();
    // const tableHeight = parseInt(document.body.clientHeight - 350);
    const { tableHeight, startTime, endTime } = this.state;
    const { changeTabState, moreFilter, showMoreFilter } = this.state;
    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);
    const dateFormat = 'YYYY-MM-DD';
    return (
      <div className="data-loading">
        <div className="form-bg">
          <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
          <div className="theme-content">
            <ConnectedHeader
              toggleCollapsed={() => changeListWidth(this)}
              login={false}
              home={true}
            />
            <div className="theme-box">
              <div className="bread-crumb">
                <Breadcrumb>{breadItem(['慧眼', '大盘数据'])}</Breadcrumb>
              </div>
              <div className="box" style={{ width: this.state.listWidth }}>
                <div className="data-search">
                  <Form
                    layout="inline"
                    className={`ant-advanced-search-form${
                      !moreFilter && showMoreFilter ? ' notOverflow' : ''
                    }`}
                  >
                    <div className="searchBox">
                      <div className="searchBoxContent">
                        <Form.Item label="日期" colon={false}>
                          {changeTabState === '5' ? (
                            <Input
                              disabled={true}
                              placeholder="当前为实时数据，不支持日期查询"
                              style={{ width: 350 }}
                            />
                          ) : (
                            <ConfigProvider allowClear={true} locale={zh_CN}>
                              {getFieldDecorator('date', {
                                initialValue:
                                  startTime && endTime
                                    ? [
                                        moment(startTime, dateFormat),
                                        moment(endTime, dateFormat),
                                      ]
                                    : null,
                              })(
                                <RangePicker
                                  onOpenChange={this.onOpenChange}
                                  disabledDate={this.disabledDate}
                                  onCalendarChange={this.onCalendarChange}
                                  allowClear={false}
                                />
                              )}
                            </ConfigProvider>
                          )}
                        </Form.Item>
                        {this.state.changeTabState === '3' ? (
                          <Form.Item label="未连续传片时长" colon={false}>
                            {getFieldDecorator('unUpDcmDays', {})(
                              <Select
                                allowClear={true}
                                placeholder="选择时长"
                                style={{
                                  width: '240px',
                                }}
                                onChange={this.changeSelectTime}
                              >
                                <Option value={7} title={'连续7天未传片'}>
                                  连续7天未传片
                                </Option>
                                <Option value={3} title={'连续3天未传片'}>
                                  连续3天未传片
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        ) : null}

                        {this.state.changeTabState === '4' ? (
                          <Form.Item label="连续登录时长" colon={false}>
                            {getFieldDecorator('loginDays', {})(
                              <Select
                                allowClear={true}
                                placeholder="选择时长"
                                style={{ width: '240px' }}
                                onChange={this.changeSelectTime2}
                              >
                                <Option value={7} title={'连续7天登录'}>
                                  连续7天登录
                                </Option>
                                <Option value={5} title={'连续5天登录'}>
                                  连续5天登录
                                </Option>
                                <Option value={3} title={'连续3天登录'}>
                                  连续3天登录
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        ) : null}

                        <Form.Item label="区域（省）" colon={false}>
                          {getFieldDecorator('area', {})(
                            <Select
                              allowClear={true}
                              placeholder="选择地区"
                              style={{ width: '240px' }}
                            >
                              {getProvinceOption(this.state.provinceList)}
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item label="项目名称" colon={false}>
                          {getFieldDecorator('project', {})(
                            <Select
                              className="institution-selection"
                              mode="multiple"
                              allowClear={true}
                              placeholder="选择项目名称"
                              style={{ width: '240px' }}
                            >
                              {getProjectOption(this.state.projectList)}
                            </Select>
                          )}
                        </Form.Item>
                      </div>
                    </div>
                    <div className="searchOptBox">
                      <Form.Item>
                        <Button
                          type="primary"
                          icon="search"
                          className="btn-search"
                          onClick={this.handleSearch}
                        >
                          搜索
                        </Button>
                        <Button
                          icon="redo"
                          className="form-btn-margin"
                          onClick={this.handleReset}
                          style={{ marginLeft: '8px' }}
                        >
                          重置
                        </Button>
                      </Form.Item>
                      {showMoreFilter && (
                        <Button
                          type="link"
                          className="moreFilter"
                          onClick={() => {
                            this.setState({ moreFilter: !moreFilter });
                          }}
                          icon={moreFilter ? 'down' : 'up'}
                        >
                          {moreFilter ? '展开' : '收起'}
                        </Button>
                      )}
                    </div>
                  </Form>
                </div>
                <div className="smarteye-data history-list">
                  <Tabs type="card" onChange={this.changeTab}>
                    <TabPane tab="数据图表 1" key="1">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={() => this.exportDetailExcel('data1')}
                      >
                        导出
                      </Button>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.date}
                        columns={columns1}
                        dataSource={this.state.marketDataList}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'tb1'),
                          total: this.state.totalTB1,
                          current: this.state.pageTB1,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'tb1'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                    <TabPane tab="数据图表 2" key="2">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={() => this.exportDetailExcel('data2')}
                      >
                        导出
                      </Button>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.date}
                        columns={columns2}
                        dataSource={this.state.marketDataRateList}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'tb2'),
                          total: this.state.totalTB2,
                          current: this.state.pageTB2,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'tb2'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                    <TabPane tab="数据图表 3" key="3">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportDetailExcel.bind(this, 'data3')}
                      >
                        导出
                      </Button>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.date}
                        columns={columns3}
                        dataSource={this.state.marketDataRateList3}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={false}
                      />
                    </TabPane>
                    <TabPane tab="数据图表 4" key="4">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportDetailExcel.bind(this, 'data4')}
                      >
                        导出
                      </Button>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={record => record.date}
                        columns={columns4}
                        dataSource={this.state.marketDataRateList4}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={false}
                      />
                    </TabPane>
                    <TabPane tab="设备监控历史" key="6">
                      <Button
                        icon="save"
                        className="smarteye-export"
                        onClick={this.exportDetailExcel.bind(this, 'data6')}
                      >
                        导出
                      </Button>
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={(record, index) => index}
                        columns={columns6}
                        dataSource={this.state.marketDataRateList6}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'tb6'),
                          total: this.state.totalTB6,
                          current: this.state.pageTB6,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'tb6'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                    <TabPane tab="实时设备监控" key="5">
                      <Table
                        className="smarteye-table"
                        loading={loadingOptions}
                        rowKey={(record, index) => index}
                        columns={columns5}
                        dataSource={this.state.marketDataRateList5}
                        scroll={{ y: tableHeight }}
                        locale={{ emptyText: <TableEmpty /> }}
                        pagination={{
                          pageSize: this.state.pageSize,
                          onChange: this.pageOnChange.bind(this, 'tb5'),
                          total: this.state.totalTB5,
                          current: this.state.pageTB5,
                          size: 'small',
                          showTotal: this.showTotal.bind(this, 'tb5'),
                          className: 'list-page',
                        }}
                      />
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(DataForm));
